export class Metrix {
    minrow: number;
    mincol: number;
    maxrow: number;
    maxcol: number;

    constructor( minrow: number, maxrow: number, mincol: number, maxcol: number ) {
        this.minrow = minrow;
        this.mincol = mincol;
        this.maxrow = maxrow;
        this.maxcol = maxcol;
    }

    get width(): number {
        return this.maxcol - this.mincol + 1;
    }

    get height(): number {
        return this.maxrow - this.minrow + 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/metrix.interface.ts